import { chains, protocols as protocolImages } from 'config/constants/assets';

import { ProtocolCategory } from 'types/protocols';

const protocolsInfo = [
  {
    chainId: 43114,
    chainName: "AVAX",
    category: ProtocolCategory.PARTNER,
    protocolSite: "https://www.flairdex.xyz/",
    protocolLogo: protocolImages.flairDexProtocol,
    protocolName: "FlairDex AMM",
    protocolLinkSite: 'https://app.flairdex.xyz/liquidity',
    twitterLink: 'https://twitter.com/FlairDefi',
    discordLink: 'https://discord.gg/aN3jjvk8KN',
    finished: false
  },
  {
    chainId: 43114,
    chainName: "AVAX",
    category: ProtocolCategory.PARTNER,
    protocolName: "Glacier AMM",
    protocolSite: 'https://www.glacierfi.com/',
    protocolLogo: protocolImages.glacierProtocol,
    protocolLinkSite: 'https://glacier.exchange/liquidity',
    twitterLink: 'https://twitter.com/Glacier_Fi',
    discordLink: 'https://discord.gg/glacierdex',
    finished: false
  },
  {
    chainId: 43114,
    chainName: "AVAX",
    category: ProtocolCategory.PARTNER,
    protocolName: "Champion",
    protocolSite: 'https://app.championfinance.io',
    protocolLinkSite: 'https://app.championfinance.io/detail/FLAIR_FLDX_aBASED',
    protocolLogo: protocolImages.champProtocol,
    twitterLink: 'https://twitter.com/Champion_io',
    discordLink: 'https://discord.gg/champion-finance',
    finished: false
  },
  {
    chainId: 43114,
    chainName: "AVAX",
    category: ProtocolCategory.PARTNER,
    protocolName: "SoliSnek AMM",
    protocolSite: 'https://www.solisnek.finance/home/',
    protocolLogo: protocolImages.solisnekProtocol,
    protocolLinkSite: 'https://solisnek.finance/liquidity',
    twitterLink: 'https://twitter.com/solisnekfi',
    discordLink: 'https://discord.gg/ERkhWdPNfD',
    finished: false
  },
  {
      chainId: 8453,
      chainName: "BASE",
      category: ProtocolCategory.PARTNER,
      protocolName: "BasoFi",
      protocolSite: 'https://www.baso.finance',
      protocolLinkSite: 'https://www.baso.finance',
      protocolLogo: protocolImages.basoProtocol,
      twitterLink: 'https://twitter.com/Baso_Finance',
      discordLink: 'https://discord.com/invite/basofinance',
      finished: false
  },
  {
    chainId: 324,
    chainName: "zkSync",
    category: ProtocolCategory.PARTNER,
    protocolName: "eZKalibur",
    protocolSite: 'https://www.ezkalibur.com/',
    protocolLinkSite: 'https://www.ezkalibur.com/swap',
    protocolLogo: protocolImages.kaliburProtocol,
    twitterLink: 'https://twitter.com/zkaliburDEX',
    discordLink: 'https://discord.com/invite/ypqHnKE5KF',
    finished: false
  },
  {
    chainId: 324,
    chainName: "zkSync",
    category: ProtocolCategory.PARTNER,
    protocolName: "veSync",
    protocolSite: 'https://vesync.finance',
    protocolLinkSite: 'https://vesync.finance',
    protocolLogo: protocolImages.veSyncProtocol,
    twitterLink: 'https://twitter.com/veSyncL2',
    discordLink: 'https://discord.com/invite/yP2FCcXH8h',
    finished: false
  },
  {
    chainId: 324,
    chainName: "zkSync",
    category: ProtocolCategory.PARTNER,
    protocolName: "DraculaFi",
    protocolSite: 'https://draculafi.xyz',
    protocolLinkSite: 'https://draculafi.xyz',
    protocolLogo: protocolImages.drakulaProtocol,
    twitterLink: 'https://twitter.com/dracula_fi',
    discordLink: 'https://discord.com/invite/draculafi',
    finished: false
  }
];

const protocolTokensInfo = [
    {
        chainId: 43114,
        chainName: "AVAX",
        name: "aBased",
        chainLogo: chains.avalanche,
        tokenAddress: "0x1C1CDF8928824dac36d84B3486D598B9799bA6c0"
    }
]

const protocolsInfos = [...protocolsInfo];
const protocolTokensInfos = [...protocolTokensInfo];

export { protocolsInfos, protocolTokensInfos };
